import { ReactElement } from 'react'

import 'dayjs/locale/ru'
import { DateInput, DateInputProps, DatesProvider } from '@mantine/dates'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants.ts'

export type DatePickerInnerProps = DateInputProps

const StyledDatePicker = styled(DateInput)`
  position: relative;
  height: 41px !important;
  width: 100%;

  .mantine-Input-wrapper {
    height: 100% !important;

    input {
      height: 100% !important;
      color: ${colors.thirdGray} !important;

      &:hover {
        border-color: ${colors.secondGray};
      }
    }
  }

  .mantine-DateInput-label {
    position: absolute;
    top: -7px;
    left: 10px;
    z-index: 1;
    width: fit-content;
    background-color: white;
    padding: 0 5px;
    font-size: 10px;
    color: ${colors.thirdGray};
    white-space: nowrap;
  }

  .mantine-InputPlaceholder-placeholder {
    color: ${colors.thirdGray};
    white-space: nowrap;
  }
`

export const DatePicker = (props: DatePickerInnerProps): ReactElement => {
  return (
    <DatesProvider settings={{ consistentWeeks: true }}>
      <StyledDatePicker
        {...props}
        locale='ru'
        valueFormat='DD.MM.YYYY'
        dateParser={(input) => {
          const parts = input.split('.')
          if (parts.length === 3) {
            const [day, month, year] = parts
            return new Date(Number(year), Number(month) - 1, Number(day))
          }
          return new Date(input)
        }}
      />
    </DatesProvider>
  )
}
